<template>
  <div>
    <sidebar :mobile="mobile" :toggleSidebar="toggleSidebar" />
    <!-- <navbar :mobile="mobile" :toggleSidebar="toggleSidebar" /> -->
    <div class="main">
      <unauthorised v-if="unauthorised" />
      <router-view v-else />
    </div>
  </div>
</template>

<script>
import sidebar from "./sidebar";
import navbar from "./navbar";
import { mapState } from "vuex";
import Unauthorised from "../resuables/unauthorised.vue";
export default {
  name: "RNPLDashboardFrame",
  components: {
    sidebar,
    navbar,
    Unauthorised
  },
  data() {
    return { mobile: false };
  },
  methods: {
    toggleSidebar() {
      this.mobile = !this.mobile;
    }
  },
  computed: {
    ...mapState("auth", ["unauthorised"])
  },
  watch: {
    $route: {
      handler(to, from) {
        if (this.unauthorised) {
          this.$store.commit("auth/unauthorised", false);
        }
        if (this.mobile == true) {
          this.mobile = false;
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  padding-left: 59px;
  padding-right: 89px;
  padding-bottom: 40px;
  background: #f4f4f4;
  min-height: 100vh;
  margin-left: 240px;
  width: calc(100% - 240px);
  position: relative;

  @media screen and (max-width: 1200px) {
    padding-left: 30px;
    padding-right: 10px;
  }
  @media screen and (max-width: 770px) {
    margin-left: 0;
    width: 100%;
    padding-right: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/RNPLDashboardFrame.vue